// Text widget. Legacy: addText (L3969), text styling (L4734-4781).
// Fabric v7: named imports (Textbox/IText); obj.set(...) unchanged.
import { Textbox, type FabricObject } from 'fabric'
import { getCanvas, state } from './../state'
import { labelPx } from './../canvas'

const TEXT_TYPES = ['textbox', 'i-text', 'text']

export function isTextObj(o: FabricObject | undefined | null): boolean {
  return !!o && TEXT_TYPES.includes((o as FabricObject).type)
}

export function addText(): Textbox {
  const { w, h } = labelPx()
  const text = new Textbox('Your Text', {
    // Fabric v7 defaults text origin to center/center (v5 was left/top); the legacy
    // editor positions by top-left, so pin origin to match (map: v7 gotcha).
    originX: 'left',
    originY: 'top',
    left: w * 0.1,
    top: h / 2 - 12,
    width: w * 0.8,
    fontFamily: 'Inter',
    fontSize: 20,
    fill: '#0f172a',
    id: 'text-' + Date.now(),
  } as ConstructorParameters<typeof Textbox>[1])
  const canvas = getCanvas()
  canvas.add(text)
  canvas.setActiveObject(text)
  canvas.requestRenderAll()
  return text
}

/** Text objects in the current selection (single or multi-select). Legacy getSelectedTextObjects. */
function selectedTextObjects(): FabricObject[] {
  const obj = state.canvas?.getActiveObject()
  if (!obj) return []
  if (typeof (obj as any).getObjects === 'function' && obj.type === 'activeselection') {
    return (obj as any).getObjects().filter(isTextObj)
  }
  return isTextObj(obj) ? [obj] : []
}

function applyToText(mutate: (o: FabricObject) => void): void {
  const texts = selectedTextObjects()
  if (texts.length === 0) return
  texts.forEach(mutate)
  getCanvas().requestRenderAll()
}

export function toggleBold(): void {
  const texts = selectedTextObjects()
  if (!texts.length) return
  const val = (texts[0] as any).fontWeight === 'bold' ? 'normal' : 'bold'
  applyToText((o) => o.set('fontWeight' as any, val))
}

export function toggleItalic(): void {
  const texts = selectedTextObjects()
  if (!texts.length) return
  const val = (texts[0] as any).fontStyle === 'italic' ? 'normal' : 'italic'
  applyToText((o) => o.set('fontStyle' as any, val))
}

export function toggleUnderline(): void {
  const texts = selectedTextObjects()
  if (!texts.length) return
  const val = !(texts[0] as any).underline
  applyToText((o) => o.set('underline' as any, val))
}

export function setTextAlign(align: 'left' | 'center' | 'right' | 'justify'): void {
  applyToText((o) => o.set('textAlign' as any, align))
}

export function applyFont(fontName: string): void {
  applyToText((o) => o.set('fontFamily' as any, fontName))
}
